import { getProducts } from '@Actions/products';
import { getUsers } from '@Actions/users';
import { RenderComponentOrLoading, SubscriptionsCardGroup } from '@Components';
import EntitlementsTable from '@Components/EntitlementsTable';
import { Grid } from '@mui/material';
import { useIsEntitlementsInitialized } from '@Selectors';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import StyledEntitlements, { PaperStyled } from './Entitlements.styles';

const Entitlements = () => {
	const dispatch = useDispatch();

	const isEntitlementsInitialized = useIsEntitlementsInitialized();

	useEffect(() => {
		dispatch(getUsers({ pageSize: 10, page: 1 }));
		dispatch(getProducts());
	}, []);

	return (
		<RenderComponentOrLoading loading={!isEntitlementsInitialized}>
			<StyledEntitlements>
				<Grid container>
					<Grid item xs={12}>
						<SubscriptionsCardGroup />
					</Grid>
					<Grid item xs={12}>
						<PaperStyled>
							<EntitlementsTable />
						</PaperStyled>
					</Grid>
				</Grid>
			</StyledEntitlements>
		</RenderComponentOrLoading>
	);
};

export default Entitlements;
